
require.register("react-bootstrap/lib/FormControls/index.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "react-bootstrap");
  (function() {
    'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _Static2 = require('./Static');

var _Static3 = _interopRequireDefault(_Static2);

exports.Static = _Static3['default'];
  })();
});